export const MailToLink = ({ email, subject, body = '', children }) => {
  let link = `mailto:${email}`
  if (!!subject || !!body) link += '?'
  if (!!subject) link += `subject=${encodeURIComponent(subject)}`
  if (!!body) link += `${subject ? '&' : ''}body=${encodeURIComponent(body)}`
  return <a href={link}>{children}</a>
}
